module.exports = __webpack_public_path__ + "img/new-step5.c0484d9f.jpg";